export default "__VITE_ASSET__REkMgMPl__"